import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "./../index";
import { Animated } from "react-animated-css";
import { Button, Form, Input, Select, Radio, Checkbox, message } from "antd";
import Idate from "./../../../assets/suc-khoe-vang/idate.png";
import Ivat from "./../../../assets/suc-khoe-vang/ivat.png";
import IvatTrue from "./../../../assets/suc-khoe-vang/ivattrue.png";
import Themnguoi from "./../../../assets/suc-khoe-vang/themnguoi.png";
import Iedit from "./../../../assets/suc-khoe-vang/iedit.png";
import Idelete from "./../../../assets/suc-khoe-vang/idelete.png";
import IUser from "../../../assets/icon_user.svg";
import IUploadImg from "../../../assets/icon_upload_img.svg";
import IClose from "../../../assets/iclose.svg";
import ModalVat from "./../modal/modalvat";
import ModalQuestion from "./../modal/modalQuestion";
import ModalAddAndEditPeople from "./../modal/modalAddAndEditPeople";
import moment from "moment";
import DatePicker from "../modal/DatePicker";
import Helper from "./../../../extra/helper";
import Service from "./../../../extra/getAPI";
import {
  Button as MuiButton,
  CircularProgress
} from "@mui/material";

const BuyerInfo = () => {
  const {
    goStep,
    setDataIsu,
    dataIsu,
    listIsu,
    setInsuredPerson,
    ActionList,
    indexEdit,
    setIndexEdit,
    packages,
    _render_quan_he,
    setListIsu,
    arrItem,
    loading,
    MessageErr
  } = useContext(AuthContext);
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [datePicker, setDatePicker] = useState({});
  const [formData, setFormData] = useState({});
  const [openVat, setOpenVat] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(false);
  const [openAddAndEdit, setOpenAddAndEdit] = useState(false);
  const [scanedCccd, setScanedCccd] = useState("");
  const [uploadingCccd, setUploadingCccd] = useState(false);
  const [fileInput, setFileInput] = useState(React.createRef());
  const { Option } = Select;

  useEffect(async () => {
    window.scrollTo(0, 0);
    if (dataIsu) {
      form.setFieldsValue(dataIsu);
      setFormData(dataIsu);
    }
  }, []);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData, form]);

  useEffect(() => {
    setMuacho();
  }, [listIsu]);

  const scanCccd = (img) => {
    let uploadLink;
    const formData = new FormData();
    formData.append("storage", "s3");
    formData.append("file", img);
    formData.append(
      "path",
      `/products/personal-accident/images/private-id/${Date.now()}-front`
    );
    setUploadingCccd(true);
    Service.apicall_upload_G2("POST", `/upload`, formData)
      .then((res) => {
        if (res?.status === 200) {
          uploadLink = res?.data?.link || ""
          if (uploadLink) {
            Service.apicallNoBase64("POST", "/api/v1/utility/ocr/private-id/scan", {
              "imgFront": uploadLink,
              "imgBack": uploadLink,
              "method": 2
            }).then((res) => {
              setUploadingCccd(false)
              if (res?.status === 200) {
                setScanedCccd(res.data?.result?.image || "");
                const dob = res.data?.result?.idCardInfo?.dob ? moment(res.data?.result?.idCardInfo?.dob, "DD/MM/YYYY") : undefined
                onChangeFormMulti([
                  { name: "buyerName", data: res.data?.result?.idCardInfo?.name || "" },
                  { name: "buyerPrivateId", data: res.data?.result?.idCardInfo?.id || "" },
                  { name: "buyerDob", data: dob },
                  { name: "buyerAddress", data: res.data?.result?.idCardInfo?.address || "" },
                  { name: "buyerGender", data: res.data?.result?.idCardInfo?.gender === "Nữ" ? 2 : 1 }
                ]);
                form.setFieldsValue({
                  buyerDob: dob
                });
              } else {
                setUploadingCccd(false);
                MessageErr("Đã xảy ra lỗi. Vui lòng thử lại!");
              }
            }).catch((err) => {
              setUploadingCccd(false);
              MessageErr("Đã xảy ra lỗi. Vui lòng thử lại!");
            });
          }
        }
      })
  };

  const scanCccdV2 = (img) => {
    let uploadLink;
    const formData = new FormData();
    formData.append("file", img);
    formData.append("productCode", "vbi-care");
    setUploadingCccd(true);
    Service.apicall_upload("POST", `/v1/products/upload/private-id`, formData)
      .then((res) => {
        if (res?.data?.success) {
          uploadLink = res?.data?.data?.url || ""
          // Service.callOpenApiNoBase64("POST", "/v1/third-party/kalapa/ocr/privateId",
          if (uploadLink) {
            Service.callOpenApiNoBase64("POST", "/v1/ocr/private-id", {
              "privateIdFrontUrl": uploadLink
            }, true).then((res) => {
              setUploadingCccd(false)
              if (res?.data?.success && res.data?.data?.idCardInfo?.id) {
                setScanedCccd(uploadLink);
                const dob = res.data?.data?.idCardInfo?.dob ? moment(res.data?.data?.idCardInfo?.dob, "DD/MM/YYYY") : undefined
                onChangeFormMulti([
                  { name: "buyerName", data: res.data?.data?.idCardInfo?.name || "" },
                  { name: "buyerPrivateId", data: res.data?.data?.idCardInfo?.id || "" },
                  { name: "buyerDob", data: dob },
                  { name: "buyerAddress", data: res.data?.data?.idCardInfo?.address || "" },
                  { name: "buyerGender", data: res.data?.data?.idCardInfo?.gender === "Nữ" ? 2 : 1 }
                ]);
                form.setFieldsValue({
                  buyerDob: dob
                });
              } else {
                setUploadingCccd(false);
                MessageErr("Đã xảy ra lỗi. Vui lòng thử lại!");
              }
            }).catch((err) => {
              setUploadingCccd(false);
              MessageErr("Đã xảy ra lỗi. Vui lòng thử lại!");
            });
          }
        }
      })
  };

  const isLoadingButtonNext = (loading) => {
    if (packages[+dataIsu?.packageId - 1]?.listFees.length < listIsu.length) {
      return true;
    }
    return loading;
  };

  const setMuacho = (targetList = listIsu) => {
    const list = targetList || [];
    const lengthFilterSelf = list.filter(
      (item) => Number(item?.relationshipWithBuyerName) === 1
    ).length;
    const lengthFilterPeople = list.filter(
      (item) => Number(item?.relationshipWithBuyerName) > 1
    ).length;
    let muachoVal = [];
    if (lengthFilterSelf > 0 && lengthFilterPeople > 0) {
      muachoVal = ["banthan", "nguoithan"];
    } else if (lengthFilterSelf > 0) {
      muachoVal = ["banthan"];
    } else if (lengthFilterPeople > 0) {
      muachoVal = ["nguoithan"];
    } else {
      muachoVal = [];
    }
    form.setFieldsValue({ muacho: muachoVal });
    setFormData((prev) => ({
      ...prev,
      muacho: muachoVal,
    }));
  };

  const isValidBuyerDob = (dob) => {
    if (!dob) return false;
    const dob2 = moment(dob, "DD/MM/YYYY", true);
    if (!dob2.isValid()) return false;
    const minDate = moment().subtract(65, "y");
    const maxDate = moment().subtract(18, "y");
    return (
      dob2.isBetween(minDate, maxDate, "day", "[]")
    );
  };

  const onFinish = useCallback(async () => {
    if (!listIsu || listIsu.length === 0) {
      MessageErr("Vui lòng thêm người được bảo hiểm!");
      return;
    }
    form
      .validateFields()
      .then((values) => {
        if (!listIsu || listIsu.length === 0) {
          MessageErr("Vui lòng thêm người được bảo hiểm!");
          return;
        }
        if (!isValidBuyerDob(values?.buyerDob)) {
          message.error('Người mua chưa đủ 18 tuổi!');
          form.setFieldsValue({ buyerDob: undefined })
          return
        }
        const vat = localStorage.getItem("vatskv");
        localStorage.setItem(
          "dataIsuVbiCare",
          JSON.stringify({ ...dataIsu, ...values })
        );
        setDataIsu({ ...dataIsu, ...values });
        goStep(4);
      })
      .catch((errorfields) => {
        if (!listIsu || listIsu.length === 0) {
          MessageErr("Vui lòng thêm người được bảo hiểm!");
        }
      });
  }, [form, listIsu, dataIsu, setDataIsu, MessageErr, goStep]);

  const onChangForm = ({ data, name }) => {
    const selfIndex = listIsu.findIndex((item) => item.relationshipWithBuyerName === 1);
    const hasSelf = selfIndex !== -1 && name !== "vat";

    if (hasSelf) {
      ActionList("delete", selfIndex, "");
    }

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: data,
      };
      if (hasSelf) {
        let currentMuacho = updated.muacho;
        if (Array.isArray(currentMuacho)) {
          currentMuacho = currentMuacho.filter((v) => v !== "banthan");
        } else if (currentMuacho === "banthan") {
          currentMuacho = "";
        }
        const nextMuacho = currentMuacho && currentMuacho.length > 0 ? currentMuacho : "";
        updated.muacho = nextMuacho;
        form.setFieldsValue({ muacho: nextMuacho });
      }
      return updated;
    });
  };

  const onChangeFormMulti = (fields) => {
    const selfIndex = listIsu.findIndex((item) => item.relationshipWithBuyerName === 1);
    const hasSelf = selfIndex !== -1;

    if (hasSelf) {
      ActionList("delete", selfIndex, "");
    }

    setFormData((prev) => {
      const updated = { ...prev };
      if (hasSelf) {
        let currentMuacho = updated.muacho;
        if (Array.isArray(currentMuacho)) {
          currentMuacho = currentMuacho.filter((v) => v !== "banthan");
        } else if (currentMuacho === "banthan") {
          currentMuacho = "";
        }
        const nextMuacho = currentMuacho && currentMuacho.length > 0 ? currentMuacho : "";
        updated.muacho = nextMuacho;
        form.setFieldsValue({ muacho: nextMuacho });
      }
      fields.forEach(({ name, data }) => {
        updated[name] = data;
        if (name === "buyerDob" && !!data) {
          updated[name] = moment(data).format("DD/MM/YYYY");
        }
      });
      return updated;
    });
  };

  const handCancel = (isSuccess) => {
    setOpenVat(false);
    setOpenQuestion(false);
    setOpenAddAndEdit(false);
    setIndexEdit(null);
    if (!isSuccess) {
      setMuacho();
    }
  };

  const Add = () => {
    form
      .validateFields()
      .then((values) => {
        setDataIsu({ ...dataIsu, ...values });
        localStorage.setItem(
          "dataIsuskv",
          JSON.stringify({ ...dataIsu, ...values })
        );
        const formattedDob =
          typeof values.buyerDob === "string"
            ? values.buyerDob
            : values.buyerDob?.isValid?.()
              ? values.buyerDob.format("DD/MM/YYYY")
              : values.buyerDob
                ? moment(values.buyerDob).format("DD/MM/YYYY")
                : "";
        setInsuredPerson({
          insuredName: values.buyerName,
          insuredPrivateId: values.buyerPrivateId,
          insuredGender: values.buyerGender,
          insuredPhone: values.buyerPhone,
          insuredEmail: values.buyerEmail,
          insuredDob: formattedDob,
          relationshipWithBuyerName: 1,
          permanentAddress: values.buyerAddress || values.address || "",
        });
        setOpenQuestion(true);
      })
      .catch((errorfields) => {
        setMuacho();
      });
  };
  return (
    <>
      {openAddAndEdit && (
        <ModalAddAndEditPeople
          open={openAddAndEdit}
          handleCancel={handCancel}
          formData={formData}
        />
      )}
      {openQuestion && (
        <ModalQuestion
          indexEdit={indexEdit}
          open={openQuestion}
          handleCancel={handCancel}
        />
      )}
      <ModalVat isModalVisible={openVat} handleCancel={handCancel} />
      {datePicker.open && (
        <DatePicker
          onConfirm={(data) => {
            const formatted = moment(data).format("DD/MM/YYYY");
            form.setFieldsValue({
              buyerDob: formatted,
            });
            onChangForm({ data: data, name: "buyerDob" });
          }}
          max={moment().subtract(18, "y").toDate()}
          min={moment().subtract(65, "y").add(0, "days").toDate()}
          visible={datePicker.open}
          close={() => {
            setDatePicker({ ...datePicker, open: false });
          }}
          value={formData.buyerDob}
          title={"Ngày sinh"}
        />
      )}
      <Form
        style={{ fontSize: 14, color: "#343A40" }}
        ref={formRef}
        form={form}
        onFinish={onFinish}
        name="step3skv"
        scrollToFirstError
        onValuesChange={(_, allValues) => {
          setFormData(allValues);
        }}
      >
        <div style={{ padding: 10 }}>
          <div style={{ ...css.title, ...css.divFlex }}>
            <div>Thông tin bảo hiểm</div>
            <img
              onClick={() => goStep(2)}
              style={{ width: 15, height: 15 }}
              src={Iedit}
              alt="Global Care"
            />
          </div>
          <div style={{ ...css.divFlex, marginTop: 10 }}>
            <span>Gói bảo hiểm:</span>
            <span>{arrItem[+dataIsu?.packageId - 1].title}</span>
          </div>
          <div style={{ ...css.divFlex, marginTop: 10 }}>
            <span>Thời hạn bảo hiểm:</span>
            <span>
              {`${dataIsu.beginDate} -
                ${moment(dataIsu.beginDate, "DD/MM/YYYY")
                  .add(1, "year")
                  .format("DD/MM/YYYY")}`}
            </span>
          </div>
        </div>
        <div style={css.driver}></div>
        <div style={{ padding: 10 }}>
          <div style={{ ...css.title, marginTop: 10, marginBottom: 10 }}>
            Thông tin người mua bảo hiểm
          </div>
          <div style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
          }}>
            <div
              style={{
                borderRadius: 8,
                padding: 5,
                backgroundColor: "#FFFFFF",
                border: "0.5px solid #D2D2D2",
                flex: 1
              }}>
              <div style={{
                position: "relative",
                ...(!scanedCccd && { display: "none" })
              }}>
                <img src={scanedCccd}
                  style={{
                    width: "100%", borderRadius: 8,
                  }}
                />
                <div
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: 5,
                    padding: 4,
                    backgroundColor: "#FFFFFF",
                    position: "absolute",
                    top: 5,
                    right: 5,
                    color: "black",
                    cursor: "pointer",
                    display: "flex"
                  }}
                  onClick={() => {
                    setScanedCccd("");
                    onChangeFormMulti([
                      { name: "buyerName", data: "" },
                      { name: "buyerPrivateId", data: "" },
                      { name: "buyerDob", data: "" },
                      { name: "buyerAddress", data: "" },
                      { name: "buyerGender", data: null },
                    ]);
                    form.setFieldsValue({
                      buyerDob: "",
                    });
                    if (fileInput?.current) {
                      setFileInput({
                        ...fileInput,
                        current: {
                          ...fileInput?.current,
                          value: ""
                        }
                      })
                    }
                  }}
                >
                  <img src={IClose} width={16} />
                </div>
              </div>
              <div
                style={{
                  borderRadius: 8,
                  padding: 5,
                  backgroundColor: scanedCccd ? "#FFFFFF" : "#F3F3F3",
                  ...(scanedCccd && { display: "none" })
                }}>
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}>
                  <img src={IUser} />
                  <MuiButton
                    component="label"
                    variant="outlined"
                    disabled={uploadingCccd || false}
                    startIcon={
                      uploadingCccd ? (
                        <CircularProgress size={20} sx={{ color: "black" }} />
                      ) : (
                        <img src={IUploadImg} width={16} alt="upload" />
                      )
                    }
                    sx={{
                      borderColor: "#D2D2D2 !important",
                      borderWidth: "0.5px !important",
                      borderRadius: "6px !important",
                      backgroundColor: "white",
                      fontWeight: 500,
                      fontSize: 12,
                      cursor: "pointer",
                      padding: "8px 12px",
                      textTransform: "none",
                      color: "black",
                      height: 30,
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                        borderColor: "#bdbdbd",
                      }
                    }}
                  >
                    {uploadingCccd ? "Đang xử lý..." : "Tải ảnh lên"}
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      name="upload_img"
                      ref={fileInput}
                      onChange={(e) => {
                        const image = e.target.files?.[0];
                        if (image) {
                          setUploadingCccd(true);
                          scanCccdV2(image)
                        }
                        e.target.value = "";
                      }}
                    />
                  </MuiButton>
                </div>
              </div>
            </div>
            <div style={{ flex: 1, padding: 0, color: "#F37021", fontStyle: "italic", fontSize: 13, textAlign: "justify" }}>
              Chụp CCCD/hộ chiếu để nhập nhanh thông tin
              {" "}
              <span style={{ color: "#9E9E9E", fontStyle: "italic", fontSize: 13 }}>
                (không bắt buộc)
              </span>
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            <div>
              Họ và tên<span style={{ color: "red" }}>*</span>
            </div>
            <Form.Item
              name="buyerName"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập thông tin",
                },
              ]}
              style={css.FormItemsHolder}

            >
              <Input
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "buyerName" });
                }}
                autoComplete="off"
                style={{ ...css.input, textTransform: "capitalize" }}
                placeholder="Nhập họ và tên"
              />
            </Form.Item>
          </div>
          <div style={{ marginTop: 10 }}>
            <div>
              Ngày sinh<span style={{ color: "red" }}>*</span>
            </div>
            <Form.Item
              name="buyerDob"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập thông tin",
                },
              ]}
              style={css.FormItemsHolder}
            >
              <Input
                autoComplete="off"
                suffix={
                  <img style={{ width: 18 }} src={Idate} alt="Global Care" />
                }
                readOnly
                style={{ ...css.input }}
                placeholder="DD/MM/YYYY"
                onClick={() => {
                  setDatePicker({ ...datePicker, open: true });
                }}
              />
            </Form.Item>
          </div>
          <div style={{ fontSize: 12, color: "#FB7800" }}>
            Phí bảo hiểm sẽ thay đổi theo độ tuổi
          </div>
          <div style={{ marginTop: 10 }}>
            <div>
              Số CCCD/ Hộ chiếu
              <span style={{ color: "red" }}>*</span>
            </div>
            <Form.Item
              name="buyerPrivateId"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập thông tin",
                },
                {
                  min: 6,
                  message: "Vui lòng nhập tối thiểu 6 kí tự.",
                  // pattern: /^[A-Z][0-9]{7}$|^[0-9]{9}$|^[0-9]{12}$/,
                },
              ]}
              style={css.FormItemsHolder}
              value={formData?.buyerPrivateId}
            >
              <Input
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "buyerPrivateId" });
                }}
                autoComplete="off"
                style={{ ...css.input }}
                placeholder="Nhập số CCCD/ Hộ chiếu"
              />
            </Form.Item>
          </div>
          <div style={{ marginTop: 10 }}>
            <div>
              Giới tính
              <span style={{ color: "red" }}>*</span>
            </div>
            <Form.Item
              name="buyerGender"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn và nhập thông tin",
                },
              ]}
              style={css.FormItemsHolder}
              value={formData?.buyerGender}
            >
              <Select
                onChange={(e) => {
                  onChangForm({ data: e, name: "buyerGender" });
                }}
                allowClear={true}
                className="custom-select-antd-no-padding-bhyt"
                placeholder="Chọn giới tính"
              >
                <Option value={1}>Nam</Option>
                <Option value={2}>Nữ</Option>
              </Select>
            </Form.Item>
          </div>
          <div style={{ marginTop: 10 }}>
            <div>
              Số điện thoại
              <span style={{ color: "red" }}>*</span>
            </div>
            <Form.Item
              name="buyerPhone"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập thông tin",
                },
                {
                  message:
                    "Vui lòng nhập SĐT định dạng số, không bao gồm ký tự đặc biệt.",
                  pattern: /((09|03|07|08|05)+([0-9]{8})\b)/,
                },
              ]}
              style={css.FormItemsHolder}
            >
              <Input
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "buyerPhone" });
                }}
                autoComplete="off"
                type="tel"
                style={{ ...css.input }}
                placeholder="Nhập số điện thoại"
              />
            </Form.Item>
          </div>
          <div style={{ marginTop: 10 }}>
            <div>
              Email
              <span style={{ color: "red" }}>*</span>
            </div>
            <Form.Item
              name="buyerEmail"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập thông tin",
                },
                {
                  message: "Email không hợp lệ",
                  pattern: /\S+@\S+\.\S+/,
                },
              ]}
              style={css.FormItemsHolder}
            >
              <Input
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "buyerEmail" });
                }}
                autoComplete="off"
                style={{ ...css.input }}
                placeholder="Nhập email"
              />
            </Form.Item>
            <div style={{ fontSize: 12, color: "#FB7800" }}>
              Nhập email để nhận giấy chứng nhận bảo hiểm
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            <div>
              Địa chỉ thường trú
              <span style={{ color: "red" }}>*</span>
            </div>
            <Form.Item
              name="buyerAddress"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập thông tin",
                },
              ]}
              style={css.FormItemsHolder}
              value={formData?.buyerAddress}
            >
              <Input
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "buyerAddress" });
                }}
                autoComplete="off"
                style={{ ...css.input }}
                placeholder="Nhập địa chỉ thường trú..."
              />
            </Form.Item>
          </div>
        </div>
        <div style={css.driver}></div>
        <div style={{ padding: 10 }}>
          <div style={css.title}>Bạn mua bảo hiểm cho ai?</div>
          <div style={{ marginTop: 10 }}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn người được bảo hiểm",
                },
              ]}
              name="muacho"
              style={css.FormItemsHolder}
            >
              <Checkbox.Group
                value={
                  Array.isArray(formData?.muacho)
                    ? formData.muacho
                    : formData?.muacho
                      ? [formData.muacho]
                      : []
                }
              >
                <Checkbox
                  onChange={(e) => {
                    if (e?.target?.checked) {
                      setTimeout(() => {
                        Add();
                      }, 100);
                    } else {
                      const selfIndex = listIsu.findIndex(
                        (item) => +item.relationshipWithBuyerName === 1
                      );
                      if (selfIndex !== -1) {
                        ActionList("delete", selfIndex, "");
                      }
                    }
                  }}
                  value="banthan"
                >
                  Cho bản thân
                </Checkbox>
                <Checkbox
                  onChange={(e) => {
                    if (e?.target?.checked) {
                      setTimeout(() => {
                        setOpenAddAndEdit(true);
                      }, 100);
                    } else {
                      ActionList("deleteParent", 0, "");
                    }
                  }}
                  value="nguoithan"
                >
                  Cho người thân
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
          </div>
          <div
            style={{
              marginTop: 10,
              display: listIsu.length > 0 ? "" : "none",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                <b>Danh sách người được BH</b>
              </div>
              <div
                onClick={() => setOpenAddAndEdit(true)}
                style={{
                  fontWeight: 500,
                  color: "#009B4B",
                  display: "flex",
                  alignItems: "center",
                  display:
                    listIsu.filter(
                      (item) => item.relationshipWithBuyerName !== 1
                    ).length > 0
                      ? ""
                      : "none",
                }}
              >
                Thêm
                <img
                  style={{ width: 18, marginLeft: 5 }}
                  src={Themnguoi}
                  alt="Global Care"
                />
              </div>
            </div>
          </div>
          {/* Danh sách người được BH */}
          {listIsu.map((data, index) => (
            <div key={index} style={css.itemPeople}>
              <div
                style={{
                  ...css.divFlex,
                  width: "100%",
                }}
              >
                <div>
                  <div
                    style={{
                      color: "#009B4B",
                      fontWeight: 500,
                      textTransform: "capitalize",
                    }}
                  >
                    {data?.insuredName}
                  </div>
                  <div style={{ fontSize: 10, color: "#646D69" }}>
                    {_render_quan_he(data?.relationshipWithBuyerName)} -{" "}
                    {data?.insuredDob}
                  </div>
                </div>
                <div style={{ textAlign: "left" }}>
                  <div style={{ fontSize: 10, color: "#646D69" }}>
                    Phí bảo hiểm
                  </div>
                  <div style={{ fontWeight: 500 }}>
                    {loading
                      ? 0
                      : Helper._formatMoney(
                        (
                          packages[+dataIsu?.packageId - 1]?.listFees || []
                        ).filter((v) => v.ten === data?.insuredName)[0]
                          ?.fees || 0
                      )}{" "}
                    VNĐ/
                    {dataIsu?.period === 1 ? "tháng" : "năm"}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: "10%",
                  justifyContent: "flex-end",
                }}
              >
                {data?.relationshipWithBuyerName !== 1 && (
                  <div>
                    <img
                      onClick={() => {
                        setIndexEdit(index);
                        setOpenAddAndEdit(true);
                      }}
                      style={{ width: 18, marginLeft: 10 }}
                      src={Iedit}
                      alt="Global Care"
                    />
                  </div>
                )}
                <div>
                  <img
                    onClick={() => {
                      ActionList("delete", index, "");
                    }}
                    style={{ marginLeft: 10, width: 13 }}
                    src={Idelete}
                    alt="Global Care"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <Animated
          animationIn="fadeInUp"
          animationInDuration={500}
          isVisible={true}
          style={{ width: "100%", position: "sticky", bottom: 0 }}
        >
          <div style={css.boxbtn}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 0px",
              }}
            >
              <span>Tổng tiền thanh toán</span>
              <span style={{ color: "#009B4B" }}>
                <b>
                  {loading || listIsu.length === 0
                    ? 0
                    : Helper._formatMoney(
                      packages[+dataIsu?.packageId - 1]?.fees || 0
                    )}{" "}
                  VNĐ
                </b>
              </span>
            </div>
            <div style={css.divFlex}>
              <Button
                onClick={() => goStep(2)}
                style={css.btnBack}
                type="#009B4B"
              >
                Quay lại
              </Button>
              <Button
                loading={isLoadingButtonNext(loading)}
                htmlType="submit"
                style={css.btnNext}
                type="#009B4B"
              >
                Tiếp tục
              </Button>
            </div>
          </div>
        </Animated>
      </Form>
    </>
  );
};

const css = {
  title: {
    fontSize: 16,
    color: "#009B4B",
    fontWeight: 600,
  },
  FormItemsHolder: {
    width: "100%",
    borderRadius: 8,
    margin: "5px 0px",
    padding: 0,
  },
  input: { borderRadius: 8, padding: 10, fontSize: 14, color: "#343A40" },
  driver: {
    width: "100%",
    height: 5,
    background: "#0000001A",
  },
  btnBack: {
    color: "#009B4B",
    background: "#FFF",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
    border: "1px solid #009B4B",
  },
  btnNext: {
    color: "#FFF",
    background: "#009B4B",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
  },
  boxbtn: {
    position: "sticky",
    bottom: 0,
    height: 96,
    background: "#fff",
    borderRadius: "16px 16px 0px 0px",
    boxShadow: "0px -4px 8px 0px #0000001A",
    padding: "0px 10px",
    marginTop: 10,
  },
  itemPeople: {
    marginTop: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 7,
    borderRadius: 5,
    background: "#F8F9FA",
  },
  divFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
};

export default BuyerInfo;
